const items = [
  "Soluzione Albania",
  "Recruiting Sanitario",
  "YUMA Coop",
  "Yurax Project",
  "Notarchain",
  "TEO Salute",
  "BRICS Gold",
  "Vodafone España",
  "Consulenza d'Impresa",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <section className="relative py-10 border-y border-[#DCEEF5] bg-white/60 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-serif-ed italic text-3xl sm:text-4xl px-6 ${i % 3 === 0 ? "text-[#0B2530]" : i % 3 === 1 ? "text-stroke-ciano" : "text-stroke-arancio"}`}>
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#06B6D4] mx-2" />
          </span>
        ))}
      </div>
    </section>
  );
};
